export const swapCheckrIllegalCharacters = (s: string) => {
  if (!s) {
    return undefined
  }

  return s.replace('’', "'")
}
